// re.rejouis.fr — SOUMISSION : écran d'attente qui poste la demande à la
// fonction serveur (écriture Airtable Demandes + Lignes) puis enchaîne sur la
// confirmation. Gère aussi le retour après connexion (auto-soumission).
import { useEffect, useRef, useState } from 'react';
import { Spinner, Icons, Sticker, Illus } from '../components/ui.jsx';
import { soumettreDemande } from '../lib/api.js';
import { abonnerNewsletter, lireEtOublierChoixNewsletter } from '../lib/newsletter.js';
import { suivre, oublierJournal } from '../lib/posthog.js';
import { lireQuestionnaire, oublierQuestionnaire } from '../lib/questionnaire.js';
import { lireVirement, enregistrerVirement } from '../lib/rachat.js';

export default function Soumission({ go, panier, client, onSucces }) {
  const [erreur, setErreur] = useState(null);
  const envoye = useRef(false);

  useEffect(() => {
    if (envoye.current) return;            // anti double-soumission (StrictMode / re-render)
    if (!client) { go('verifications'); return; }
    if (!panier.length) { go('accueil'); return; }
    envoye.current = true;
    // IBAN saisi au panier ; le serveur recalcule chaque montant de virement.
    const virement = panier.some((l) => l.paiement === 'virement') ? lireVirement() : null;

    soumettreDemande({
      client: { id: client.id, email: client.email },
      lignes: panier.map((l) => (l.lot ? {
        // Lot : estimé à la main, étiquette différée (cf. netlify/functions/demande.js).
        lot: true,
        quantite: l.quantite,
        notes: l.notes,
        photos: (l.photos || []).map((p) => ({ b64: p.b64, mime: p.mime })),
      } : {
        produitId: l.produitId,
        variantId: l.variantId,
        ficheRef: l.ficheRef || null,
        handle: l.handle,
        titre: l.titre,
        etatDeclare: l.etatDeclare,
        accessoiresIncomplets: l.accessoiresIncomplets,
        credit: l.credit,
        virement: l.paiement === 'virement', // choisi à l'écran État
      })),
      type: 'standard',
      questionnaire: lireQuestionnaire(), // raison, ancienneté, petit mot (écran Vérifications)
      virement: virement ? { iban: virement.iban, titulaire: virement.titulaire } : null,
    })
      .then((res) => {
        const submissionDetails = {
          item_count: panier.reduce((count, ligne) => count + (ligne.lot ? ligne.quantite || 0 : 1), 0),
          total_credit: panier.reduce((total, ligne) => total + (ligne.credit || 0), 0),
          includes_lot: panier.some((ligne) => ligne.lot),
        };
        suivre('reprise_request_submitted', submissionDetails);
        oublierJournal();
        oublierQuestionnaire();
        enregistrerVirement(null); // l'IBAN ne reste pas dans le navigateur
        // Case newsletter cochée à l'écran Vérifications → inscription, sans bloquer.
        if (lireEtOublierChoixNewsletter()) abonnerNewsletter(client.email);
        onSucces(res);
      })
      .catch((e) => setErreur(e.message));
  }, [client, panier, go, onSucces]);

  if (erreur) {
    return (
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 14, padding: 24, textAlign: 'center' }}>
        <Illus nom="oups" size={64} />
        <div style={{ fontWeight: 700, fontSize: 16 }}>Échec de l’envoi</div>
        <div style={{ fontSize: 13, color: 'var(--stone)', maxWidth: 320, lineHeight: 1.5 }}>{erreur}</div>
        <button className="btn btn-primary" onClick={() => { envoye.current = false; go('verifications'); }}>Réessayer</button>
      </div>
    );
  }

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 14, padding: 24 }}>
      <Sticker nom="sourire" size={88} anim="flotte" />
      <Spinner size={22} label="On enregistre ta demande…" />
    </div>
  );
}
